// ============================================================
// data/compliance.ts — 5 selos de conformidade do Lume
// ============================================================

export interface ComplianceBadge {
  id: string;
  iconKey: 'lgpd' | 'cfm' | 'lei14510' | 'anvisa' | 'cep';
  short: string;
  full: string;
  body: string;
}

export const complianceBadges: ReadonlyArray<ComplianceBadge> = [
  {
    id: 'lgpd',
    iconKey: 'lgpd',
    short: 'LGPD',
    full: 'Lei 13.709/2018 — Lei Geral de Proteção de Dados',
    body:
      'DPA assinado com Google, RIPD v1 publicado, retenção definida por coleção. Encarregado (DPO) formalmente indicado.',
  },
  {
    id: 'cfm',
    iconKey: 'cfm',
    short: 'CFM 2.314/2022',
    full: 'Resolução CFM 2.314/2022 — Telemedicina',
    body:
      'Telemedicina autorizada com identificação inequívoca do médico, MFA fresh em prescrição e assinatura digital ICP-Brasil.',
  },
  {
    id: 'lei14510',
    iconKey: 'lei14510',
    short: 'Lei 14.510/2022',
    full: 'Lei 14.510/2022 — Telessaúde no SUS',
    body:
      'Telessaúde como modalidade autorizada de prestação de serviços de saúde mediada por TICs. Acesso público garantido.',
  },
  {
    id: 'anvisa',
    iconKey: 'anvisa',
    short: 'ANVISA SaMD',
    full: 'ANVISA — Software como Dispositivo Médico',
    body:
      'Classificação preliminar Classe I (baixo risco) com avaliação contínua conforme funcionalidades de IA evoluírem.',
  },
  {
    id: 'cep',
    iconKey: 'cep',
    short: 'CEP-CONEP',
    full: 'CEP-CONEP — Comissão Nacional de Ética em Pesquisa',
    body:
      'Submissão ao sistema Plataforma Brasil prevista para o estudo controlado (M8). TCLE/TALE granulares prontos.',
  },
];
